"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _timer = require("@package/timer");

var notifications = _interopRequireWildcard(require("@package/notifications"));

var _axios = _interopRequireDefault(require("axios"));

var _react = _interopRequireWildcard(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var Message = function Message() {
  var _useState = (0, _react.useState)(window.env['RELOAD_TIME']),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  var handleReloadPage = function handleReloadPage() {
    window.location.reload();
  };

  (0, _react.useEffect)(function init() {
    var timerInstance = setInterval(function () {
      var newCount = count - 1;

      if (newCount === 0) {
        handleReloadPage();
        return void 0;
      }

      setCount(newCount);
    }, 1024);
    return function () {
      clearInterval(timerInstance);
    };
  }, [count]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['message']
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: _defaultModule["default"]['message__content']
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _defaultModule["default"]['button'],
    onClick: handleReloadPage
  }, "\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435"), " \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0434\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F \u0440\u0430\u0431\u043E\u0442\u044B.", /*#__PURE__*/_react["default"].createElement("br", null), "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0434\u0435\u0442 \u0447\u0435\u0440\u0435\u0437 ", count, " \u0441\u0435\u043A."));
};

var _default = function () {
  var version = null;
  var dispatch = null;
  var timer = new _timer.Timer();

  var send = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
      var _yield$axios, data;

      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0, _axios["default"])({
                url: process.env['PUBLIC_URL'] + '/version.json',
                method: 'get',
                header: {
                  'Cache-Control': 'no-cache'
                }
              });

            case 3:
              _yield$axios = _context.sent;
              data = _yield$axios.data;

              if (version === null) {
                version = data['version'];
              }

              if (version !== data['version']) {
                version = data['version'];
                dispatch(notifications.push({
                  title: 'Доступно обновление личного кабинета',
                  content: /*#__PURE__*/_react["default"].createElement(Message, null),
                  mode: 'primary',
                  autoClose: false
                }));
              }

              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              console.error('Ошибка проверки версии', _context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function send() {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    start: function start() {
      timer.start(send, window.env['ATTEMPT_CHECK_VERSION']);
    },
    stop: function stop() {
      timer.reset();
    },
    middleware: function middleware(disp) {
      dispatch = disp;
    }
  };
}();

exports["default"] = _default;